/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_MnnlichInputs */

const en__field_enum_mnnlich = /** @type {(inputs: _Field_Enum_MnnlichInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`male`)
};

const de__field_enum_mnnlich = /** @type {(inputs: _Field_Enum_MnnlichInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`männlich`)
};

/**
* | output |
* | --- |
* | "male" |
*
* @param {_Field_Enum_MnnlichInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_enum_mnnlich = /** @type {((inputs?: _Field_Enum_MnnlichInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_MnnlichInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_mnnlich(inputs)
	return de__field_enum_mnnlich(inputs)
});